<template>
    <footer class="footer">
        <div class="columns">
            <div class="column">
                <h1 class="is-size-5">About SMP&CO Partners</h1>
                <p>SMP&CO Partners, Inc. is a strategy innovations, management consultancy, and technology importer & developer based in Manila, Philippines.</p>
            </div>
            <div class="column">
                <h1>SMP&CO Partners, Inc. | Bluestar Worldwide Logistics Corp.</h1><br>
                <span>3F Chamber of Commerce of the Philippine Islands Bldg.</span><br>
                <span>3 Magallanes Drive, Intramuros, City of Manila. Philippines 1002</span><br>
                <span>Contact Number: (+63) 905 522 0916</span><br>
                <span>Email: admin@smpcopartners.com</span>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>